import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostActivateSharingPayload, PostActivateSharingResponse } from '@/api/shareData/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postActivateSharing = (payload: PostActivateSharingPayload): Promise<PostActivateSharingResponse> => {
    return axios.post('/device/activate-sharingpermissionspublic', payload);
};

type UsePostActivateSharingOptions = {
    config?: MutationConfig<typeof postActivateSharing>;
    data?: PostActivateSharingPayload;
};

export const usePostActivateSharing = ({ config }: UsePostActivateSharingOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postActivateSharing,
        onSuccess: (data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Deviced data sharing activated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('activate sharing'),
    });
};
